module.exports = __webpack_public_path__ + "img/emt_pantografi.d6c29cba.png";